<template>
  <expandable-nav-drawer
    v-if="expandable"
    :hide-logo="hideLogo"
    :logo="logo"
    :menu-options="menuOptions"
    :footer-options="footerOptions"
    :absolute="absolute"
    :rounded="rounded"
    :expanded="expanded"
    :space-between-options="spaceBetweenOptions"
    @footer="onClickFooter"
    @click="onClick"
    @click:logo="onClickLogo"
  />
  <default-nav-drawer
    v-else
    :hide-logo="hideLogo"
    :menu-options="menuOptions"
    :absolute="absolute"
    :rounded="rounded"
    :expanded="expanded"
    :space-between-options="spaceBetweenOptions"
    :logo="logo"
    :footer-options="footerOptions"
    @footer="onClickFooter"
    @click="onClick"
    @click:logo="onClickLogo"
  />
</template>

<script>
import DefaultNavDrawer from './_private/DefaultNavigationDrawer.vue'
import ExpandableNavDrawer from './_private/ExpandableNavigationDrawer.vue'

/**
 * Nav drawer Facade
 *
 * Os modelos de Nav drawer devem implementar as
 * opções disponibilizadas dentro deles.
 *
 * Caso não sejam implementadas, isso deve ser indicado na documentação
 */

/**
 * @displayName Navigation Drawer
 */
export default {
  name: 'ZNavigationDrawer',
  components: {
    DefaultNavDrawer,
    ExpandableNavDrawer,
  },
  props: {
    /**
     * Opções a serem adicionadas ao menu
     */
    menuOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    /**
     * Opções para serem adicionadas na parte de baixo do nav drawer
     */
    footerOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    /**
     * Flag para esconder a logo
     */
    hideLogo: {
      type: Boolean,
      default: false,
    },
    /**
     * Caminho da logo para ser colocada no nav drawer
     */
    logo: {
      type: String,
      default: require('../../../assets/img/logo-branca.svg'),
    },
    /**
     * Flag para deixar o nav drawer absoluto
     */
    absolute: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para utilizar a versão expandable do nav drawer
     */
    expandable: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para indicar que o menu deve se manter aberto
     */
    expanded: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para deixar o nav drawer arredondado
     */
    rounded: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para dar um espaçamento entre as opções principais e as do footer
     */
    spaceBetweenOptions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentNavBar() {
      return this.expandable
        ? 'z-expandable-nav-drawer'
        : 'z-default-nav-drawer'
    },
  },
  methods: {
    onClick(ev) {
      /**
       * Evento disparado quando o usuário clica na opção do menu
       *
       * @property {object} option - Opção clicada pelo usuário
       *
       */
      this.$emit('click', ev)
    },
    onClickFooter(menuOption) {
      /**
       * Evento disparado quando o usuário clica em uma opção do footer
       *
       * @property {object} menuOption - Opção clicada pelo usuário
       */
      this.$emit('footer', menuOption)
    },
    onClickLogo() {
      /**
       * Evento disparado quando o usuário clica na logo do menu
       *
       */
      this.$emit('click:logo')
    },
  },
}
</script>
